// compared to term search, the number of changes is very small -
// we simply add non zero size to make sure top matching documents are also included in response
export const suggestionsForTermInCategoryQuery = `
  {
   "query": {
    "bool": {
      "must": [
        {
          "term": {
            "category": {
              "value": "<%=category%>"
            }
          }
        }
        <%=termSubquery%>
      ]
    }
  },
  "aggs": {
    "top_values": {
      "terms": {
         "field": "value.precise",
        "size": <%=maxCount%>
      },
      "aggs": {
        "known_categories": {
          "terms": {
             "field": "category",
              "size": <%=maxCount%>
          }
        }
      }
    }
  },
  "size": <%=maxCount%>
}
`;
